import script from "./VideoExportAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoExportAdd.vue?vue&type=script&setup=true&lang=js"

import "./VideoExportAdd.vue?vue&type=style&index=0&id=8b49d2f4&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b49d2f4"]])

export default __exports__